import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {RouterLink} from '@angular/router';

import {AuthService} from '@app/auth/auth.service';
import {StorageService} from '@app/shared/storage.service';

@Component({
    selector: 'frog-try-block',
    templateUrl: './try-block.component.html',
    styleUrls: ['./try-block.component.scss'],
    imports: [MatButton, RouterLink],
})
export class TryBlockComponent implements OnInit {
    constructor(
        private storageService: StorageService,
        private authService: AuthService,
    ) {}

    ngOnInit(): void {}

    login() {
        this.storageService.set('signup', true);
        this.authService.redirectToIdp();
    }
}
